import React from 'react';
import {
  Box,
  Tooltip,
  FormControl,
  Collapse,
  FormControlLabel,
  RadioGroup,
  Radio,
  makeStyles
} from '@material-ui/core';
import CheckCircleSharpIcon from '@material-ui/icons/CheckCircleSharp';
import { Typography as SwagupTypography } from '@swagup-com/components';
import { Info } from '@material-ui/icons';
import { shoppingExperienceColors } from '../../shared/constants';

const styles = () => ({
  radioRoot: {
    border: `1px solid ${shoppingExperienceColors.disabledCta}`,
    borderRadius: 8,
    width: '400px',
    padding: '10px',
    marginBottom: '20px',
    cursor: 'pointer',
    '&.selected': {
      borderColor: shoppingExperienceColors.primary,
      cursor: 'pointer',
      backgroundColor: shoppingExperienceColors.primaryNewBgColor
    },
    transition: 'all 0.3s ease'
  },
  radioChecked: {
    color: `${shoppingExperienceColors.primary} !important`
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  checkIcon: {
    color: shoppingExperienceColors.ctaHover,
    fontSize: 18
  },
  collapseStyle: {
    listStyleType: 'none'
  },
  bulletListPO: {
    listStyleType: 'none',
    paddingLeft: '0px',
    marginBottom: '0px !important'
  },
  bulletItemPO: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    listStyleType: 'none',
    gap: '10px'
  },
  customTooltip: {
    fontFamily: 'Inter',
    fontSize: '14px'
  }
});

const useStyles = makeStyles(styles);

const PurchaseOptions = ({ selected, onChange }) => {
  const classes = useStyles();
  const handleChange = value => onChange(value);

  return (
    <FormControl component="fieldset">
      <SwagupTypography variant="body2SemiBoldInter" className={classes.smallHeadings} style={{ marginBottom: '8px' }}>
        Purchase options
      </SwagupTypography>
      <RadioGroup value={selected} onChange={e => handleChange(e.target.value)}>
        <Box
          id="projectDetails-radioBulk-selected"
          data-cy="projectDetails-radioBulk-selected"
          className={`${classes.radioRoot} ${selected === 'bulk' ? 'selected' : ''}`}
          onClick={() => handleChange('bulk')}
          role="button"
        >
          <FormControlLabel
            value="bulk"
            control={
              <Radio
                color="default"
                classes={{
                  checked: classes.radioChecked
                }}
              />
            }
            label={
              <Box className={classes.labelContainer}>
                <SwagupTypography variant="body2MediumInter">Buy in Bulk</SwagupTypography>
                <div className={classes.designPriceInfo} style={{ marginLeft: 5 }}>
                  <Tooltip
                    placement="right"
                    title="Choose Bulk if you need branded items delivered in large quantities, unpackaged, and ready to distribute however you’d like"
                    arrow
                    classes={{
                      tooltip: classes.customTooltip
                    }}
                  >
                    <Info
                      style={{ fontSize: 28, marginTop: 2, paddingTop: 10, color: shoppingExperienceColors.black }}
                    />
                  </Tooltip>
                </div>
              </Box>
            }
          />
          <Collapse className={classes.collapseStyle} in={selected === 'bulk'}>
            <ul className={classes.bulletListPO}>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">
                  Perfect for events, office swag and client gifts
                </SwagupTypography>
              </li>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">Distribution options to meet your needs</SwagupTypography>
              </li>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">Dedicated Swag Expert</SwagupTypography>
              </li>
            </ul>
          </Collapse>
        </Box>

        <Box
          id="projectDetails-radioSwag-selected"
          data-cy="projectDetails-radioSwag-selected"
          className={`${classes.radioRoot} ${selected === 'swag' ? 'selected' : ''}`}
          onClick={() => handleChange('swag')}
          role="button"
        >
          <FormControlLabel
            value="swag"
            control={
              <Radio
                color="default"
                classes={{
                  checked: classes.radioChecked
                }}
              />
            }
            label={
              <Box className={classes.labelContainer}>
                <SwagupTypography variant="body2MediumInter">Add to a Swag Pack</SwagupTypography>
                <div className={classes.designPriceInfo} style={{ marginLeft: 5 }}>
                  <Tooltip
                    placement="right"
                    title="Choose Swag Pack if you want items grouped and pre-packed into curated kits — ideal for onboarding, gifting, or special events"
                    arrow
                    classes={{
                      tooltip: classes.customTooltip
                    }}
                  >
                    <Info
                      style={{ fontSize: 28, marginTop: 2, paddingTop: 10, color: shoppingExperienceColors.black }}
                    />
                  </Tooltip>
                </div>
              </Box>
            }
          />
          <Collapse className={classes.collapseStyle} in={selected === 'swag'}>
            <ul className={classes.bulletListPO}>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">Assembly & Packaging</SwagupTypography>
              </li>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">Warehouse & Inventory Management</SwagupTypography>
              </li>
              <li className={classes.bulletItemPO}>
                <CheckCircleSharpIcon className={classes.checkIcon} />
                <SwagupTypography variant="body4RegularInter">Dedicated Swag Expert</SwagupTypography>
              </li>
            </ul>
          </Collapse>
        </Box>
      </RadioGroup>
    </FormControl>
  );
};

export default PurchaseOptions;
